export const ADDITIONAL = {
    en: {
        registration_promo: `Register in our catalog and use the promo code BINI24 on your first purchase to get a 5% discount.`,
    },
    fr: {
        registration_promo: `Inscrivez-vous dans notre catalogue et utilisez le code promo BINI24 lors de votre premier achat pour obtenir une réduction de 5 %.`,
    },
    es: {
        registration_promo: `Regístrate en nuestro catálogo y usa el código promocional BINI24 en tu primera compra para obtener un 5% de descuento.`,
    },
    ua: {
        registration_promo: `Зареєструйтесь у нашому каталозі та використовуйте промокод BINI24 при першій покупці, щоб отримати знижку 5%.`,
    },
    pl: {
        registration_promo: `Zaregistrujte se v našem katalogu a použijte promo kód BINI24 při první objednávce, abyste získali slevu 5 %.`,
    },
    cz: {
        registration_promo: `Zaregistrujte se v našem katalogu a použijte promo kód BINI24 při první objednávce, abyste získali slevu 5 %.`,
    },
    ru: {
        registration_promo: `Зарегистрируйтесь в нашем каталоге и при первой покупке используйте промокод BINI24, чтобы получить скидку 5%.`,
    },
    kz: {
        registration_promo: `Біздің каталогқа тіркеліп, бірінші сатып алуда BINI24 промокодын енгізіп, 5% жеңілдік алыңыз.`,
    },
};
